import corruptingPotion from './corrupting_potion.png'
import deadMansPlate from './dead_mans_plate.png'
import divineSunderer from './divine_sunderer.png'
import dorans_shield from './dorans_shield.png'
import dorans_blade from './dorans_blade.png'
import executioners_calling from './executioners_calling.png'
import goredrinker from './goredrinker.png'
import hullbreaker from './hullbreaker.png'
import ravenous_hydra from './ravenous_hydra.png'
import seryldas_grudge from './seryldas_grudge.png'
import spirit_visage from './spirit_visage.png'
import steraks_gage from './steraks_gage.png'
import stride_breaker from './stride_breaker.png'
import titanic_hydra from './titanic_hydra.png'
import trinity_force from './trinity_force.png'

const itemsList = {
  corruptingPotion: corruptingPotion,
  deadMansPlate: deadMansPlate,
  divineSunderer: divineSunderer,
  doransShield: dorans_shield,
  doransBlade: dorans_blade,
  executionersCalling: executioners_calling,
  goreDrinker: goredrinker,
  hullBreaker: hullbreaker,
  ravenousHydra: ravenous_hydra,
  seryldasGrudge: seryldas_grudge,
  spiritVisage: spirit_visage,
  steraksGage: steraks_gage,
  strideBreaker: stride_breaker,
  titanicHydra: titanic_hydra,
  trinityForce: trinity_force,
}

export default itemsList
